class TechnicalSpecificationsComponent extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
    this.sectionEl = this;
    this.currentVariantId = this.getVariantFromUrl();
  }

  connectedCallback() {
    this._loadSection();

    window.addEventListener('popstate', () => this.checkVariantChange());
    const pushState = history.pushState;
    history.pushState = (...args) => {
      pushState.apply(history, args);
      this.checkVariantChange();
    };
    const replaceState = history.replaceState;
    history.replaceState = (...args) => {
      replaceState.apply(history, args);
      this.checkVariantChange();
    };
  }

  getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  checkVariantChange() {
    const newVariantId = this.getVariantFromUrl();
    if (newVariantId && newVariantId !== this.currentVariantId) {
      this.currentVariantId = newVariantId;
      this._loadSection();
    }

  }

  async _loadSection() {
    const sectionIdAttr = this.sectionEl.dataset.sectionId;
    if (!sectionIdAttr) return;

    const variantParam = this.currentVariantId ? `&variant=${this.currentVariantId}` : '';
    const url = `${window.location.pathname}?section_id=${sectionIdAttr}${variantParam}`;

    try {
      const response = await fetch(url, { priority: 'low' });
      const htmlText = await response.text();

      const tempDoc = new DOMParser().parseFromString(htmlText, 'text/html');
      const newComponent = tempDoc.querySelector('technical-specifications-component');

      if (newComponent) {
        this.replaceChildren(...document.importNode(newComponent, true).childNodes);
        this._initViewMore();
        this._checkDescriptionHeight();
        this._isLoaded = false;
      }
    } catch (error) {
      console.error('Error loading technical specifications:', error);
      this._isLoaded = false;
    }
  }

  _initViewMore() {
    const viewMoreBtn = this.querySelector(".section-stack__intro .js-view-more");
    const description = this.querySelector(".section-stack__intro-description");

    if (viewMoreBtn && description && !viewMoreBtn.dataset.listenerAdded) {
      viewMoreBtn.addEventListener("click", () => {
        description.classList.toggle("full-content");
      });
      viewMoreBtn.dataset.listenerAdded = "true";
    }
  }


  _checkDescriptionHeight() {
    const description = this.querySelector(".section-stack__intro-description");
    if (!description) return;

    const fullHeight = description.scrollHeight - 40;
    if (fullHeight <= 324) {
      description.classList.add("short-content");
    } else {
      description.classList.remove("short-content");
    }
  }
}

if (!window.customElements.get('technical-specifications-component')) {
  window.customElements.define('technical-specifications-component', TechnicalSpecificationsComponent);
}


class ProductFaqComponent extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
    this.sectionEl = this;
    this.currentVariantId = this.getVariantFromUrl();
  }

  connectedCallback() {
    this._loadSection();

    window.addEventListener('popstate', () => this.checkVariantChange());
    const pushState = history.pushState;
    history.pushState = (...args) => {
      pushState.apply(history, args);
      this.checkVariantChange();
    };
    const replaceState = history.replaceState;
    history.replaceState = (...args) => {
      replaceState.apply(history, args);
      this.checkVariantChange();
    };
  }

  getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  checkVariantChange() {
    const newVariantId = this.getVariantFromUrl();
    if (newVariantId && newVariantId !== this.currentVariantId) {
      this.currentVariantId = newVariantId;
      this._loadSection();
    }

  }

  async _loadSection() {
    const sectionIdAttr = this.sectionEl.dataset.sectionId;
    if (!sectionIdAttr) return;

    const variantParam = this.currentVariantId ? `&variant=${this.currentVariantId}` : '';
    const url = `${window.location.pathname}?section_id=${sectionIdAttr}${variantParam}`;

    try {
      const response = await fetch(url, { priority: 'low' });
      const htmlText = await response.text();

      const tempDoc = new DOMParser().parseFromString(htmlText, 'text/html');
      const newComponent = tempDoc.querySelector('product-faq-component');

      if (newComponent) {
        this.replaceChildren(...document.importNode(newComponent, true).childNodes);

        this._isLoaded = false;
      }
    } catch (error) {
      console.error('Error loading technical specifications:', error);
      this._isLoaded = false;
    }
  }
}
if (!window.customElements.get('product-faq-component')) {
  window.customElements.define('product-faq-component', ProductFaqComponent);
}



class VariantGalleryGridComponent extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
    this.sectionEl = this;
    this.currentVariantId = this.getVariantFromUrl();
  }

  connectedCallback() {
    this._loadSection();

    window.addEventListener('popstate', () => this.checkVariantChange());
    const pushState = history.pushState;
    history.pushState = (...args) => {
      pushState.apply(history, args);
      this.checkVariantChange();
    };
    const replaceState = history.replaceState;
    history.replaceState = (...args) => {
      replaceState.apply(history, args);
      this.checkVariantChange();
    };
  }

  getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  checkVariantChange() {
    console.log("checkVariantChange>>>>>")
    const newVariantId = this.getVariantFromUrl();
    if (newVariantId && newVariantId !== this.currentVariantId) {
      this.currentVariantId = newVariantId;
      this._loadSection();
    }

  }

  async _loadSection() {
    const sectionIdAttr = this.sectionEl.dataset.sectionId;
    if (!sectionIdAttr) return;

    const variantParam = this.currentVariantId ? `&variant=${this.currentVariantId}` : '';
    const url = `${window.location.pathname}?section_id=${sectionIdAttr}${variantParam}`;

    try {
      const response = await fetch(url, { priority: 'low' });
      const htmlText = await response.text();

      const tempDoc = new DOMParser().parseFromString(htmlText, 'text/html');
      const newComponent = tempDoc.querySelector('variant-gallery-grid-component');

      if (newComponent) {
        this.replaceChildren(...document.importNode(newComponent, true).childNodes);

        this._isLoaded = false;
      }
    } catch (error) {
      console.error('Error loading technical specifications:', error);
      this._isLoaded = false;
    }
  }
}
if (!window.customElements.get('variant-gallery-grid-component')) {
  window.customElements.define('variant-gallery-grid-component', VariantGalleryGridComponent);
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderLength = this.slider.getAttribute('data-slider-products-to-show');

    new Swiper(this.slider, {
      slidesPerView: this.sliderLength,
      spaceBetween: 24,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 16
        },
        991: {
          slidesPerView: this.sliderLength
        }
      }
    });
  }
}

customElements.define('slider-component', SliderComponent);